import { render, staticRenderFns } from "./LegalPersonsEntityDetails.vue?vue&type=template&id=1364a22f&scoped=true&"
import script from "./LegalPersonsEntityDetails.vue?vue&type=script&lang=js&"
export * from "./LegalPersonsEntityDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1364a22f",
  null
  
)

export default component.exports